import React, { useContext, useState, useRef } from "react";
import * as XLSX from 'xlsx';
import '../abmProducts/AbmProducts.css';
import './AbmBloqueadoReserva.css';
import bloqueadosReservaContext from "../../context/bloqueadosReserva/bloqueadosReservaContext";
import Swal from 'sweetalert2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBackspace } from "@fortawesome/free-solid-svg-icons";

const createEmpty = () => ({ nroSocio: "", nombre: "", textoAdicional: "" });

const AbmBloqueadoReserva = ({ setShowAbm = () => {}, itemToEdit = {}, setItemToEdit = () => {} }) => {
    const isEditing = Object.keys(itemToEdit).length > 0;

    const [formData, setFormData] = useState(isEditing ? itemToEdit : null);
    const [rowsData, setRowsData] = useState([createEmpty()]);
    const fileInputRef = useRef(null);

    const bContext = useContext(bloqueadosReservaContext);
    const { agregarBloqueado, modificarBloqueado, eliminarBloqueado, actualizarBloqueados } = bContext;

    const handleChange = (e, i = -1) => {
        const { name, value } = e.target;

        if (isEditing) {
            setFormData({ ...formData, [name]: value });
        } else {
            setRowsData((prev) => {
                let newRows = prev.slice();
                newRows[i][name] = value;
                if (value !== '') {
                    if (newRows[i].nroSocio !== '' && newRows[i].nombre !== '' && newRows.length === i + 1) {
                        newRows.push(createEmpty());
                    }
                } else {
                    if (newRows[i].nroSocio === '' && newRows[i].nombre === '' && newRows[i].textoAdicional === '') {
                        newRows.splice(i, 1);
                    }
                }
                return newRows;
            });
        }
    }

    const handleDeleteRow = (i) => {
        setRowsData((prev) => {
            let newRows = prev.filter((_, index) => index !== i);
            if (newRows.length === 0) newRows.push(createEmpty());
            return newRows;
        });
    }

    const handleFile = (file) => {
        if (!file) return;
        const reader = new FileReader();
        reader.onload = (evt) => {
            const binaryString = evt.target.result;
            const wb = XLSX.read(binaryString, { type: 'binary' });
            const sheet = wb.Sheets[wb.SheetNames[0]];
            const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

            let parsed = jsonData.filter((row, i) => i > 0 && row.length > 0).map((row) => ({
                nroSocio: row[0] != null ? String(row[0]) : "",
                nombre: row[1] != null ? String(row[1]) : "",
                textoAdicional: row[2] != null ? String(row[2]) : ""
            }));

            setRowsData((prev) => {
                let merged = [...parsed];
                let remaining = prev.filter(p => p.nroSocio !== '' && !parsed.some(m => m.nroSocio === p.nroSocio));
                return [...merged, ...remaining, createEmpty()];
            });
        }
        reader.readAsBinaryString(file);
    }

    const handleChangeFile = (e) => {
        handleFile(e.target.files[0]);
    }

    const handleDrop = (e) => {
        e.preventDefault();
        handleFile(e.dataTransfer.files[0]);
    }

    const handleSave = async () => {
        if (isEditing) {
            if (formData.nroSocio.trim() === '' || formData.nombre.trim() === '') {
                Swal.fire({ title: 'Campos requeridos', text: 'Nro. Socio y Nombre son obligatorios', icon: 'warning' });
                return;
            }
            const res = await modificarBloqueado(formData._id, {
                nroSocio: formData.nroSocio,
                nombre: formData.nombre,
                textoAdicional: formData.textoAdicional
            });
            if (res) {
                Swal.fire({ title: 'Actualizado', text: 'Registro actualizado correctamente', icon: 'success' });
                actualizarBloqueados();
            }
        } else {
            if (rowsData.some((r, i) => i < rowsData.length - 1 && (r.nroSocio === '' || r.nombre === ''))) {
                let result = await Swal.fire({
                    title: 'Ops!',
                    icon: 'warning',
                    text: 'Ciertos registros están sin completar, desea omitirlos y guardar igual?',
                    showConfirmButton: true,
                    showCancelButton: true,
                    confirmButtonColor: '#ff0000',
                    confirmButtonText: 'Sí, estoy seguro',
                    cancelButtonText: 'No',
                });
                if (!result.isConfirmed) return;
            }
            let completed = rowsData.filter(r => r.nroSocio !== '' && r.nombre !== '');
            let counterSaved = 0;
            let counterFail = 0;
            for (const r of completed) {
                try {
                    let res = await agregarBloqueado(r);
                    if (res === false) throw new Error("Error al guardar " + r.nroSocio);
                    counterSaved++;
                } catch (error) {
                    console.log("error guardando bloqueado " + r.nroSocio);
                    console.log(error);
                    counterFail++;
                }
            }
            actualizarBloqueados();
            Swal.fire({
                title: 'Resultado',
                icon: counterFail === 0 && counterSaved > 0 ? 'success' : counterFail > 0 && counterSaved === 0 ? 'error' : 'warning',
                html: `Registros guardados con éxito: ${counterSaved}. <br>Registros con error: ${counterFail}`,
            });
        }
        handleClose();
    }

    const handleDeleteItem = async () => {
        const result = await Swal.fire({
            title: 'Eliminar registro',
            text: '¿Está seguro de que desea eliminar este registro?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff0000',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        });
        if (result.isConfirmed) {
            const res = await eliminarBloqueado(formData._id);
            if (res) {
                Swal.fire({ title: 'Eliminado', text: 'Registro eliminado correctamente', icon: 'success' });
                actualizarBloqueados();
            }
            handleClose();
        }
    }

    const handleClose = () => {
        if (isEditing) {
            setItemToEdit({});
        } else {
            setShowAbm(false);
        }
    }

    return (
        <div className="abmProductsModal">
            <div className="abmProductsDiv">
                <button className="minimizarBtn" onClick={handleClose}>X</button>
                <h2>{isEditing ? 'Edición - Bloqueado para Reservar' : 'Alta - Bloqueados para Reservar'}</h2>

                <div className="productosLeidosSubtabla">
                    <div className={`bloqueadoLabels ${isEditing ? 'bloqueadoLabelsEdit' : ''}`}>
                        {!isEditing && <label></label>}
                        <label>Nro. Socio</label>
                        <label>Nombre</label>
                        <label>Motivo</label>
                    </div>
                    {isEditing ?
                        <div className="bloqueadoRow bloqueadoRowEdit">
                            <input name="nroSocio" onChange={handleChange} value={formData.nroSocio} />
                            <input name="nombre" onChange={handleChange} value={formData.nombre} />
                            <input name="textoAdicional" onChange={handleChange} value={formData.textoAdicional} />
                        </div>
                    :
                        rowsData.map((r, i) => (
                            <div className="bloqueadoRow" key={i}>
                                <FontAwesomeIcon className="iconDelete" icon={faBackspace} color="red" onClick={() => handleDeleteRow(i)} />
                                <input name="nroSocio" onChange={(e) => handleChange(e, i)} value={r.nroSocio} />
                                <input name="nombre" onChange={(e) => handleChange(e, i)} value={r.nombre} />
                                <input name="textoAdicional" onChange={(e) => handleChange(e, i)} value={r.textoAdicional} placeholder="Deuda, suspensión, etc." />
                            </div>
                        ))
                    }
                </div>
                {!isEditing && <a href="/templateBloqueados.xlsx" download>Descargar template.xlsx</a>}
                {!isEditing && <div className="inputFileXlsx dropNivel1"
                    onClick={() => fileInputRef.current.click()}
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={handleDrop}
                >
                    <span>O cargue los registros arrastrando un archivo .xlsx a esta sección</span>
                    <input ref={fileInputRef} type="file" accept=".xlsx,.xls" style={{ display: 'none' }} onChange={handleChangeFile} />
                </div>}
                <div style={{ display: 'flex', gap: '1rem', marginTop: '0.5rem' }}>
                    <button className="saveBtn" onClick={handleSave}>Guardar</button>
                    {isEditing && <button className="saveBtn" style={{ backgroundColor: '#ff0000' }} onClick={handleDeleteItem}>Eliminar</button>}
                </div>
            </div>
        </div>
    );
}

export default AbmBloqueadoReserva;
